import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import { useMemo } from "react";

import Streamlines from "./Streamlines";

function Artery({ stenosis }) {

  const geometry = useMemo(() => {
    const path = new THREE.CatmullRomCurve3([
      new THREE.Vector3(-2, 0, 0),
      new THREE.Vector3(-1, 0.3, 0),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(1, -0.2, 0),
      new THREE.Vector3(2, 0, 0),
    ]);

    return new THREE.TubeGeometry(
      path,
      100,
      0.15 * (1 - 0.6 * stenosis),
      16,
      false
    );
  }, [stenosis]);
  /*
    const material = useMemo(() => {
      return new THREE.MeshStandardMaterial({
        color: new THREE.Color().setHSL(
          0.6 * (1 - stenosis),
          1,
          0.5
        ),
      });
    }, [stenosis]);
    */
  const solidMaterial = useMemo(
    () =>
      new THREE.MeshStandardMaterial({
        color: new THREE.Color().setHSL(
          0.6 * (1 - stenosis),
          1,
          0.5
        ),
        transparent: true,
        opacity: 0.85,
      }),
    [stenosis]
  );

  const wireframeMaterial = useMemo(
    () =>
      new THREE.MeshBasicMaterial({
        color: "white",
        wireframe: true,
      }),
    []
  );

  //return <mesh geometry={geometry} material={material} />;
  return (
    <group position={[0, 0.05, 0]}>
      {/* Solid artery */}
      <mesh geometry={geometry} material={solidMaterial} />

      {/* Mesh wireframe overlay */}
      <mesh geometry={geometry} material={wireframeMaterial} />
    </group>
  );
}

export function ArteryScene({ stenosis, diameterMm, flowMlPerS, velocityMPerS, pressureDropPa }) {
  /*
  const baseDiameter = 0.15; // meters or normalized units
  const diameter = baseDiameter * (1 - 0.6 * stenosis); // example
  const flowRate = Math.pow(1 - stenosis, 4); // simple Poiseuille approx
  */
  return (
    <div style={{ position: "relative", width: "100%", height: 400 }}>
      <Canvas camera={{ position: [0, 0, 5], fov: 45 }}>
        <ambientLight intensity={0.5} />
        <directionalLight position={[5, 5, 5]} />

        {/* Artery with mesh visualization */}
        <Artery stenosis={stenosis} />
        {/* Streamline visualization
        <Streamlines stenosis={stenosis} /> */}
      </Canvas>

      {/* Overlay metrics */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          fontSize: "18px",
          color: "black",
          padding: "10px",
        }}
      >
        {/*
        <div>Stenosis: {(stenosis * 100).toFixed(1)}%</div>
        <div>Diameter: {diameter.toFixed(2)}</div>
        <div>Flow Rate: {flowRate.toFixed(2)}</div>
        */}
        <table style={{ padding:0, margin:0 }}>
          <tr>
            <td className="font-source-sans font-size-18 font-weight-400 txt-000">Stenosis: {(stenosis * 100).toFixed(1)} %</td>
            <td className="font-source-sans font-size-18 font-weight-400 txt-000">Flow Rate: {flowMlPerS.toFixed(1)} mL/s</td>
          </tr>
          <tr>
            <td className="font-source-sans font-size-18 font-weight-400 txt-000">Diameter: {diameterMm.toFixed(2)} mm</td>
            <td className="font-source-sans font-size-18 font-weight-400 txt-000">Velocity: {velocityMPerS.toFixed(2)} m/s</td>
          </tr>
          <tr>
            <td colSpan={2} className="font-source-sans font-size-18 font-weight-400 txt-000">ΔP: {(pressureDropPa / 133.322).toFixed(1)} mmHg</td>
          </tr>
        </table>
      </div>
    </div>
  );
}
